export enum DashboardOrdersColumnEnum {
    ORDER_NAME,
    STATUS,
    REQUESTER,
    NUMBER_OF_REACTIONS,
    DATE_CREATED,
}

export const dashboardOrderTableColumnText: Record<DashboardOrdersColumnEnum, string> = {
    [DashboardOrdersColumnEnum.ORDER_NAME]: 'order.list.table.column.orderName',
    [DashboardOrdersColumnEnum.STATUS]: 'order.list.table.column.status',
    [DashboardOrdersColumnEnum.REQUESTER]: 'order.list.table.column.requester',
    [DashboardOrdersColumnEnum.NUMBER_OF_REACTIONS]: 'order.list.table.column.noOfReactions',
    [DashboardOrdersColumnEnum.DATE_CREATED]: 'order.list.table.column.dateCreated',
};
